module.exports = __webpack_public_path__ + "static/media/acceuil_4.1791d45e.jpg";